import styled from "@mui/material/styles/styled";
import Typography from "@mui/material/Typography";

import * as PolicyUtils from "@app/common/utils/policyUtils";

import Link from "@rui/Link";

const TermsText = styled(Typography)(({ theme }) => ({
  color: theme.palette.shades.neutral[500],
  margin: theme.spacing(2, 0),
  textAlign: "center",
  minHeight: "42px",
  maxWidth: "390px",
}));

const TermsSection = ({ context }: { context: "signin" | "signup" }) => (
  <TermsText variant="labelMed">
    {context === "signup" ? "By creating an account" : "By signing in"}, I agree
    to Read's{" "}
    <Link href={PolicyUtils.newUserTermsOfServiceLink()}>Terms of Service</Link>{" "}
    and acknowledge I have read the{" "}
    <Link href={PolicyUtils.newUserPrivacyPolicyLink()}>Privacy Policy</Link>.
  </TermsText>
);

export default TermsSection;
